import React, { useEffect, useState } from 'react';
import { db } from './firebase.js';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import bookstore from './assets/scontistiche/bookstore.png';
import clima from './assets/scontistiche/clima.png';
import wega from './assets/scontistiche/wega.png';
import spritzeria from './assets/scontistiche/spritzeria.png';
import cgil from './assets/scontistiche/cgil.png';
import ubik from './assets/scontistiche/ubik.png';
import officegreen from './assets/scontistiche/officegreen.png';
import caffe from './assets/scontistiche/caffe.png';
import saccone from './assets/scontistiche/saccone.png';
import thundervape from './assets/scontistiche/thundervape.png';
import setteregioni from './assets/scontistiche/setteregioni.png';
import grimm from './assets/scontistiche/grimm.png';
import './Scontistiche.css';

// vecchie scontistiche statiche
const vecchieScontistiche = [
  { nome: 'Bookstore', logo: bookstore, descrizione: '5% su libri universitari - 15% scolastica universitaria' },
  { nome: 'Clima Vintage', logo: clima, descrizione: 'Convenzione 15%' },
  { nome: 'Wega', logo: wega, descrizione: '10% su lauree' },
  { nome: 'Spritzeria', logo: spritzeria, descrizione: '1€ di sconto' },
  { nome: 'CGIL', logo: cgil, descrizione: 'ISEE universitario gratuito' },
  { nome: 'Ubik', logo: ubik, descrizione: '5% su libri, 10% su cartoleria' },
  { nome: 'Office Green', logo: officegreen, descrizione: '15% su tesi, fotocopie e cartoleria' },
  { nome: 'Caffè Strega', logo: caffe, descrizione: '10% su tutto' },
  { nome: 'Michele Saccone', logo: saccone, descrizione: '12€ capelli, 15€ barba e capelli, 10% donna' },
  { nome: 'Thundervape', logo: thundervape, descrizione: '20% su tutto' },
  { nome: 'Sette Regioni', logo: setteregioni, descrizione: '20% di sconto' },
  { nome: 'Grimm Tattoo', logo: grimm, descrizione: '20% dal flashbook - 2x1 minimal' },
];

export default function Scontistiche() {
  const [nuoveScontistiche, setNuoveScontistiche] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSconti = async () => {
      setLoading(true);
      try {
        const q = query(collection(db, 'scontistiche'), orderBy('createdAt', 'desc'));
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setNuoveScontistiche(data);
      } catch (err) {
        console.error("Errore fetch scontistiche:", err);
      }
      setLoading(false);
    };

    fetchSconti();
  }, []);

  return (
    <div className="scontistiche-container">
      <h2>Scontistiche CUSAS</h2>
      {loading && <p>Caricamento...</p>}
      <div className="scontistiche-list">
        {vecchieScontistiche.map((sconto, index) => (
          <div key={`vecchia-${index}`} className="sconto-card">
            <img src={sconto.logo} alt={sconto.nome} className="sconto-logo" />
            <div className="sconto-info">
              <h3>{sconto.nome}</h3>
              <p>{sconto.descrizione}</p>
            </div>
          </div>
        ))}
        {nuoveScontistiche.map((sconto) => (
          <div key={sconto.id} className="sconto-card">
            {sconto.logo && <img src={sconto.logo} alt={sconto.nome} className="sconto-logo" />}
            <div className="sconto-info">
              <h3>{sconto.nome}</h3>
              <p>{sconto.descrizione}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
